(function () {
    'use strict';

    angular
        .module('oddModule')
        .directive('oddExternalParty', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope        = _.clone(boxTmplScope);

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller', function ($rootScope, $scope, $controller) {
                /**
                 * @property {{
                 *      ODDExternalPartyID,
                 *      ODDExternalParties: []
                 * }} boxModel
                 * @property {{
                 *      BusinessUnit: {ODDBusinessUnitID}
                 * }} boxContext
                 */

                // Box Template
                $scope.baseTemplatePath = '/app/shared/odd/externalParty/oddExternalParty.[Template].tpl.html';

                $controller('BoxTmplController', {$scope: $scope});

                $scope.goToExternalParty = function (externalParty) {
                    $scope.clickOnBox({ externalParty: externalParty });
                };
            }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);

                scope.$watch('boxModel', function (newValue) {
                    if (!newValue) return;

                    if (!_.isUndefined(scope.boxModel.ImplementationDate)) {
                        scope.boxModel.ImplementationDate = moment(scope.boxModel.ImplementationDate).format();
                    }
                });
            }
        }
    }
})();